import { defineMessages } from 'react-intl';

export default defineMessages({
	documentTitle: {
		defaultMessage: 'Requests',
		description: 'title of the request list page',
		id: 'cv.request.list.document.title',
	},
	title: {
		defaultMessage: 'Requests',
		description: 'headline of the request list page',
		id: 'cv.request.list.title',
	},
});
